import React from "react";
import SportsLayoutComp from "../../../components/sports/sports layout/SportsLayoutComp";
const Soccer = () => {
  return (
    <SportsLayoutComp name={'Soccer'}/>
  );
};

export default Soccer;
